<template>
  <RevCard
    class="flex flex-row items-start p-16"
    data-qa="replacement-order"
    data-test="replacement-order"
  >
    <RevIllustration
      v-if="image.href"
      :alt="title"
      data-test="replacement-order-picture"
      :height="128"
      :src="image.href"
      :width="128"
    />
    <div class="ml-8">
      <h3 class="body-1-bold" data-test="replacement-order-title">
        {{ title }}
      </h3>

      <p class="body-2 text-static-default-low">
        {{ i18n(translations.replacementOrderConditionLabel) }}
      </p>
      <p
        v-if="isAnUpgrade"
        class="body-2 mb-4 flex flex-row items-center gap-4"
        data-test="replacement-order-grade"
      >
        <span>{{ previousGradeLabel }}</span>
        <IconArrowRight size="small" />
        <span class="body-2-bold bg-static-brand-hi">{{ gradeLabel }}</span>
      </p>
      <p v-else class="body-2 mb-4" data-test="replacement-order-condition">
        {{ gradeLabel }}
      </p>

      <FormattedMessage
        class="text-static-default-low body-2"
        data-test="replacement-order-seller"
        :definition="translations.replacementOrderSeller"
      >
        <template #link>
          <RevLink target="_blank" :to="seller.shopLink">
            {{ seller.company }}
          </RevLink>
        </template>
      </FormattedMessage>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import type { LinkExternal } from '@backmarket/http-api/src/api-models/LinkExternal'
import type { LinkInternal } from '@backmarket/http-api/src/api-models/LinkInternal'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { IconArrowRight } from '@ds/icons/IconArrowRight'

import translations from './XrReplacementOrderDetailsCard.translations'

interface ReplacementOrderCardProps {
  title: string
  image: LinkExternal
  isAnUpgrade: boolean
  gradeLabel: string
  previousGradeLabel: string
  seller: {
    company: string
    shopLink: LinkInternal
  }
}

defineProps<ReplacementOrderCardProps>()

const i18n = useI18n()
</script>
